// extracted by mini-css-extract-plugin
export var gif = "_lb-0";